import React from 'react';
import SideMenuWrapper from './SideMenu.style';
import Logo from './Logo/Logo';
import MenuComponent from '../SideMenu/Menu/Menu';

const SideMenu = ({role,openKeys,selectedKeys,onSubMenuSelect,onMenuItemClick}) => {
    return (
        <SideMenuWrapper>
            <Logo />
            <MenuComponent
                role={role}
                openKeys={openKeys}
                selectedKeys={selectedKeys}
                onSubMenuSelect={onSubMenuSelect}
                onMenuItemClick={onMenuItemClick} />
        </SideMenuWrapper>
    )
}

export default SideMenu;


// WEBPACK FOOTER //
// ./src/components/SideMenu/SideMenu.js